// extracted by mini-css-extract-plugin
export default {"wrapper":"SQFGgHumg1iKen3ybIig"};